<template>
  <div>
    <div class="bk">
      <div class="one">智慧交通</div>
      <div class="two">
        般极活性济众己率况八史次等较音与县断青话号选子次成流加约元派产王日线消精军知比口门对每眼形过政保经同改金特极近那性京段元物土机亲气细调治。
      </div>
    </div>
    <div class="cecurity">
      <div class="title">科技治超</div>
      <div class="content">
        <span
          >智能安防系统可以简单理解为：图像的传输和存储、数据的存储和处理准确而选择性操作的技术系统。就智能化安防系统来说，一个完整的智能安防系统主要包括门禁、报警和监控三大部分。</span
        >
      </div>
    </div>
    <div class="three">
      <div></div>
      <div></div>
      <div></div>
    </div>

    <div class="architecture">
      <div class="title">道路监控</div>
      <div class="content">
        <span
          >智能安防系统可以简单理解为：图像的传输和存储、数据的存储和处理准确而选择性操作的技术系统。就智能化安防系统来说，一个完整的智能安防系统主要包括门禁、报警和监控三大部分。</span
        >
      </div>
    </div>
    <div class="four">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div class="air">
      <div class="title">运营车辆管理</div>
      <div class="content">
        <span
          >智能安防系统可以简单理解为：图像的传输和存储、数据的存储和处理准确而选择性操作的技术系统。就智能化安防系统来说，一个完整的智能安防系统主要包括门禁、报警和监控三大部分。</span
        >
      </div>
    </div>
    <div class="airthree">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "architecture",
  data() {
    return {};
  }
};
</script>

<style scoped>
.bk {
  position: relative;
  background-color: red;
  width: 100vw;
  height: 87.3333vw;
  background-image: url(../assets/img/建筑智能化_banner_mob.png);
  background-size: 100% 100%;
}
.bk .one {
  position: absolute;
  top: 38.9333vw;
  left: 34.2667vw;
  font-family: AlibabaPuHuiTiB;
  color: #ffffff;
  line-height: 8.6667vw;
  letter-spacing: 1.6vw;
  font-size: 6.4vw;
}
.bk .two {
  position: absolute;
  width: 89.3333vw;
  height: 17.4667vw;
  top: 56.8vw;
  left: 5.3333vw;
  font-family: AlibabaPuHuiTiB;
  color: #ffffff;
  letter-spacing: 0.1333vw;
  font-size: 3.2vw;
  text-align: center;
  line-height: 5.3333vw;
}

.cecurity {
  margin-top: 8vw;
  margin-left: 4vw;
  width: 92vw;
  height: 54.6667vw;
  box-shadow: 0px 1px 10px 0px rgba(176, 183, 213, 0.2);
}

.cecurity .title {
  width: 21.4333vw;
  padding-top: 7.4667vw;
  height: 6.4vw;
  margin: 0 auto;
  font-size: 5.0667vw;
  letter-spacing: 0.2667vw;
  line-height: 6.4vw;
}
.cecurity .content {
  padding-top: 4.5333vw;
  margin: 0 auto;
  width: 316px;
  height: 60px;
  color: #01021b;
  opacity: 0.72;
}
.cecurity .content span {
  /* Transform的 scale属性不能作用于 inline元素上，例如span */
  display: inline-block;
  width: 168vw;
  height: 32vw;
  font-size: 5.3333vw;
  letter-spacing: 0.2667vw;
  line-height: 10.6667vw;
  transform: scale(0.5);
  transform-origin: left;
  transform-origin: 0% 0%;
}
.three {
  margin-top: 4.2667vw;
  margin-left: 4vw;
  width: 92vw;
  height: 69.0667vw;
}

.three div:nth-child(1) {
  float: left;
  left: 0px;
  width: 43.7333vw;
  height: 69.0667vw;
  background-image: url(../assets/img/智能安防1_mob.png);
  background-size: 100% 100%;
}
.three div:nth-child(2) {
  float: right;
  top: 0px;
  right: 0px;
  width: 44.2667vw;
  height: 32.5333vw;
  background-image: url(../assets/img/智能安防2_mob.png);
  background-size: 100% 100%;
}
.three div:nth-child(3) {
  float: right;
  margin-top: 4vw;
  right: 0px;
  width: 44.2667vw;
  height: 32.5333vw;
  background-image: url(../assets/img/智能安防3_mob.png);
  background-size: 100% 100%;
}
.architecture {
  margin-top: 10.6667vw;
  margin-left: 4vw;
  width: 92vw;
  height: 54.6667vw;
  box-shadow: 0px 1px 10px 0px rgba(176, 183, 213, 0.2);
}
.architecture .title {
  width: 26.7333vw;
  padding-top: 7.4667vw;
  height: 6.4vw;
  margin: 0 auto;
  font-size: 5.0667vw;
  letter-spacing: 0.2667vw;
  line-height: 6.4vw;
}
.architecture .content {
  padding-top: 4.5333vw;
  margin: 0 auto;
  width: 316px;
  height: 60px;
  color: #01021b;
  opacity: 0.72;
}
.architecture .content span {
  /* Transform的 scale属性不能作用于 inline元素上，例如span */
  display: inline-block;
  width: 168vw;
  height: 32vw;
  font-size: 5.3333vw;
  letter-spacing: 0.2667vw;
  line-height: 10.6667vw;
  transform: scale(0.5);
  transform-origin: left;
  transform-origin: 0% 0%;
}
.four {
  margin-top: 4.2667vw;
  margin-left: 4vw;
  width: 92vw;
  height: 72.8vw;
}

.four div:nth-child(1) {
  float: left;
  width: 43.7333vw;
  height: 48vw;
  background-image: url(../assets/img/建筑智能化1_mob.png);
  background-size: 100% 100%;
}
.four div:nth-child(2) {
  float: right;
  width: 44.2667vw;
  height: 11.7333vw;
  background-image: url(../assets/img/建筑智能化2_mob.png);
  background-size: 100% 100%;
}
.four div:nth-child(3) {
  float: right;
  margin-top: 4vw;
  right: 0px;
  width: 44.2657vw;
  height: 57.0667vw;
  background-image: url(../assets/img/建筑智能化4_mob.png);
  background-size: 100% 100%;
}
.four div:nth-child(4) {
  float: left;
  margin-top: 4vw;
  left: 0px;
  width: 43.7333vw;
  height: 20.5333vw;
  background-image: url(../assets/img/建筑智能化3_mob.png);
  background-size: 100% 100%;
}

.air {
  margin-top: 20vw;
  margin-left: 4vw;
  width: 92vw;
  height: 54.6667vw;
  box-shadow: 0px 1px 10px 0px rgba(176, 183, 213, 0.2);
}
.air .title {
  width: 42.1333vw;
  padding-top: 7.4667vw;
  text-align: center;
  height: 6.4vw;
  margin: 0 auto;
  font-size: 4.2667vw;
  letter-spacing: 0.2667vw;
  line-height: 6.4vw;
  color: #140047;
}
.air .content {
  padding-top: 4.5333vw;
  margin: 0 auto;
  width: 316px;
  height: 60px;
  color: #01021b;
  opacity: 0.72;
}
.air .content span {
  /* Transform的 scale属性不能作用于 inline元素上，例如span */
  display: inline-block;
  width: 168vw;
  height: 32vw;
  font-size: 5.3333vw;
  letter-spacing: 0.2667vw;
  line-height: 10.6667vw;
  transform: scale(0.5);
  transform-origin: left;
  transform-origin: 0% 0%;
}
.airthree {
  margin-top: 4.2667vw;
  margin-left: 4vw;
  width: 345px;
  height: 69.0667vw;
}
.airthree div:nth-child(1) {
  float: left;
  background-image: url(../assets/img/中央空调节能系统1_mob.png);
  width: 43.7333vw;
  height: 49.0667vw;
  background-size: 100% 100%;
}

.airthree div:nth-child(2) {
  float: right;
  right: 0;
  background-image: url(../assets/img/中央空调节能系统2_mob.png);
  width: 44.2667vw;
  height: 69.0667vw;
  background-size: 100% 100%;
}

.airthree div:nth-child(3) {
  float: left;
  margin-top: 4vw;
  right: 0;
  background-image: url(../assets/img/中央空调节能系统3_mob.png);
  width: 44.2667vw;
  height: 16vw;
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/traffic.vue